import React, { lazy } from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import MyTeam from "@/pages/travelClaims/MyTeam";
const MyActivity = lazy(() =>
  import("@/pages/myDayatWork/employee/Index")
);
const MyReport = lazy(() =>
  import("@/pages/myDayatWork/employee/MyReport")
);
const LaravelPage = lazy(() =>
  import("@/components/common/laravelMydayatwork")
);
const TeamActivity = lazy(() =>
  import("@/pages/myDayatWork/reporting/Index")
);
// const ReportingManager = lazy(() =>
//   import("@/pages/projectWave/ReportingManagerWave")
// );
// const Reviewer = lazy(() =>
//   import("@/pages/projectWave/Reviewer")
// );
// const DivisionHead = lazy(() =>
//   import("@/pages/projectWave/DivisionHead")
// );

const MyDayAtWork = [
  // {
  //   path: "projectwave",
  //   element: (
  //     <SuspenseWrapper>
  //       <ProjectWaves />
  //     </SuspenseWrapper>
  //   ),
  // },

  {
    path: "mydayactivity",
    element: (
      <SuspenseWrapper>
        <LaravelPage />
      </SuspenseWrapper>
    ),
  },
  // {
  //   path: "myreport",
  //   element: (
  //     <SuspenseWrapper>
  //       <MyReport />
  //     </SuspenseWrapper>
  //   ),
  // },

  {
    path: "myactivity",
    element: (
      <SuspenseWrapper>
        <MyActivity />
      </SuspenseWrapper>
    ),
  },
  {
    path: "TeamActivity",
    element: (
      <SuspenseWrapper>
        <TeamActivity />
      </SuspenseWrapper>
    ),
  },


  // {
  //   path: "projectreviewer",
  //   element: (
  //     <SuspenseWrapper>
  //       <Reviewer />
  //     </SuspenseWrapper>
  //   ),
  // },
  // {
  //   path: "projectdivision",
  //   element: (
  //     <SuspenseWrapper>
  //       <DivisionHead />
  //     </SuspenseWrapper>
  //   ),
  // },
];

export default MyDayAtWork;
